<style lang="postcss">
	.description {
		align-self: flex-start;
		font-size: 0.85rem;
		line-height: 1.5;
		opacity: 0.65;
		padding-bottom: 0.1rem;
		padding: 0.15rem 0;
	}
</style>

<script lang="ts">
	export let html: string;
</script>

<div class="description">
	{@html html}
</div>
